<template>
  <div >
    <div v-if="errStatus" class="err-msg">
      <p>授权失败</p>
      <p>请返回APP，重新进入商城</p>
    </div>
  </div>
</template>
<script>
// import { thirdPartLogin } from '@/api/user'
import { Dialog } from 'vant'
export default {
  name: 'thirdLogin',
   beforeRouteLeave(to, from, next) {
    // 这里可以编写需要执行的代码

    this.errStatus = false;
    // 调用next()将控制权交还给路由器进行导航
    next();
  },
  data () {
    return {
      errStatus: false
    }
  },
  watch: {
    $route: {
      immediate: true,
      async handler (to, from) {
        const { exe_token, loginError } = to.query
        if (exe_token) {
          const result = await this.$store.dispatch('user/thirdLogin', { exe_token }).catch((err) => {
            console.log(err);
              Dialog.alert({
              title: '登录失败',
              }).then(() => {
                this.errStatus = true
              // on close
            });
          });
          if (result.status) {
            this.$router.push('/')
          } else {
            Dialog.alert({
              title: '登录失败',
              message: ''
            }).then(() => {
               this.errStatus = true
            });
          }
        }
        if (loginError && loginError === '1') {
          this.errStatus = true
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  .err-msg {
    font-size: 0.30rem;
    margin-top: 6rem;
    color: red;
    text-align: center;
  }
</style>
